import request from '@/config/request'

export default {

  getNoAuthWechatUserInfo: function (appKey, code) {
    return request({
      url: '/wechat/auth/getnoauthwechatuserinfo',
      method: 'get',
      params: {
        appkey: appKey,
        code: code
      }
    })
  },

  getAuthWechatUserInfo: function (appKey, code) {
    return request({
      url: '/wechat/auth/getauthwechatuserinfo',
      method: 'get',
      params: {
        appkey: appKey,
        code: code
      }
    })
  },

  authJsApi: function (appKey, targetUrl) {
    return request({
      url: '/wechat/auth/authjsapi',
      method: 'get',
      params: {
        appkey: appKey,
        targeturl: targetUrl
      }
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/wechat/auth.js